import { createTheme } from "@mui/material/styles";
import { grey } from "@mui/material/colors";

export const theme = createTheme({
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            scrollbarColor: "#535354",
            "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
              backgroundColor: "rgb(225, 225, 222)",
              width: '0.75em',
              height: '0.5em',
            },
            "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
              borderRadius: 2,
              backgroundColor: "#aaa7a7",
              // "#6b6b6b",
              minHeight: 24,
              border: "3px solid #aaa7a7",
            },
            "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
              backgroundColor: "#9b9a9a",
            },
            "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
              backgroundColor: "#707070",
            },
            "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#8a8a8a",
            },
            "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
              backgroundColor: "#747474",
            },
          },
          MuiTooltip: {
            tooltip: {
              fontsize: "1em",
            },
          },
          typography: {
            allVariants: {
              fontFamily: 'B Nazanin',
            },
          },
        },
      },
      MuiRadio: {
        styleOverrides: {
          root: {
            color: grey[600],
          },
          colorSecondary: {
            '&$checked': {
              color: grey[800],
            },
          },
        }
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            allVariants: {
              fontFamily: 'B Nazanin',
            },
          }
        }

    }
    },
    breakpoints: {
      values: {
        xs: 425,
        sm: 768,
        md: 1024,
        lg: 1200,
        xl: 1440,
      },
    },
  });

